<template>
  <div id="app">
    <head-bar></head-bar>
    <login v-if="$store.state.loginButton"></login>
    <div id="router">
      <router-view></router-view>
    </div>
    <tail></tail>
  </div>
</template>

<script>
import headBar from "@/components/headBar";
import tail from "@/components/tail";
import login from "@/components/login";
export default {
  name: 'app',
  components:{
    headBar,
    tail,
    login
  }
}
</script>
<style scoped>
@import url('reset.css');
#app {
  font-family: 'Arial Normal', 'Arial';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1200Px;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#router {
  flex: auto;
}
</style>
